module.exports = __webpack_public_path__ + "img/left-carousel.b69725ff.svg";